import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axios';

// Async thunk to fetch general settings
export const fetchGeneralSettings = createAsyncThunk(
    'settings/fetchGeneralSettings',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get('/user/general');
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to fetch settings');
        }
    }
);

const settingsSlice = createSlice({
    name: 'settings',
    initialState: {
        data: {
            address: '',
            bussinessEmail: '',
            mobile1: '',
            mobile2: '',
            callUsText: '',
            freeDeliveryText: '',
            websiteLink: '',
            facebookHandle: '',
            instagramHandle: '',
            privacyPolicy: '',
            termsAndCondition: '',
            cookies: '',
            disclaimer: '',
            shippingFee: 80,
            freeShippingThreshold: 699
        },
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchGeneralSettings.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchGeneralSettings.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchGeneralSettings.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default settingsSlice.reducer;
